module.exports = __webpack_public_path__ + "img/wire-3.a8b6e912.jpg";